import {
    ApiRequestError,
    ApiResponseError,
    ApiResponseParseError,
    ApiTransportError
} from '@tadpoles/api-client'

export type PasswordResetFailure = 'invalid-credential' | 'offline' | 'unverifiable'

const InvalidCredentialErrorCodes = new Set(['expired_token', 'invalid_token', 'no_token'])

export function getPasswordResetFailure(error: unknown): PasswordResetFailure {
    if (error instanceof ApiTransportError) {
        return 'offline'
    }

    if (
        error instanceof ApiResponseError &&
        error.error &&
        InvalidCredentialErrorCodes.has(error.error.code)
    ) {
        return 'invalid-credential'
    }

    if (
        error instanceof ApiRequestError ||
        error instanceof ApiResponseError ||
        error instanceof ApiResponseParseError
    ) {
        return 'unverifiable'
    }

    throw error
}
